import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useResetPasswordMutation } from "./authApiSlice";
import {
  Stack,
  TextField,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
//import HighlightIcon from "@mui/icons-material/Highlight";
//import { yellow } from "@mui/material/colors";
import { ReactComponent as MarkNotesIcon } from "../../logo.svg";
//const color = yellow[500];
const PWD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
function PasswordReset() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [pw, setPw] = useState({
    password: "",
    confirmPassword: "",
  });
  const [error, setError] = useState({
    password: "",
    confirmPassword: "",
  });
  const [
    resetPassword,
    {
      isSuccess: isResetSuccess,
      isError: isResetError,
      isLoading: isResetLoading,
      error: errorReset,
      reset,
    },
  ] = useResetPasswordMutation();
  function handleOnChange(event) {
    const { value, name } = event.target;
    setPw((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
    validateInput(event);
  }
  function validateInput(e) {
    let { name, value } = e.target;
    setError((prev) => {
      const stateObj = { ...prev, [name]: "" };
      switch (name) {
        case "password":
          if (!value) {
            stateObj[name] = "Please enter Password!";
          } else if (pw.confirmPassword && value !== pw.confirmPassword) {
            stateObj["confirmPassword"] =
              "Password and Confirm Password does not match!";
          } else if (!PWD_REGEX.test(value)) {
            stateObj[name] =
              "Password must contain Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character!";
          } else {
            stateObj["confirmPassword"] = pw.confirmPassword
              ? ""
              : error.confirmPassword;
          }
          break;

        case "confirmPassword":
          if (!value) {
            stateObj[name] = "Please enter Confirm Password!";
          } else if (pw.password && value !== pw.password) {
            stateObj[name] = "Password and Confirm Password does not match!";
          }
          break;
        default:
          break;
      }

      return stateObj;
    });
  }
  async function handleSubmit(event) {
    event.preventDefault();
    if (!error.password && !error.confirmPassword) {
      await resetPassword({ password: pw.password, token: token });
    }
  }
  useEffect(() => {
    if (isResetSuccess) {
      setPw(null);
      setError(null);
    }
  }, [isResetSuccess, isResetLoading, reset, navigate]);
  const errClass = isResetError ? "errmsg" : "offscreen";
  if (isResetLoading) {
    return (
      <Stack alignItems="center" spacing={5}>
        <CircularProgress />
      </Stack>
    );
  }
  if (isResetSuccess) {
    return (
      <div>
        <header className="reset-pw-header">
          <MarkNotesIcon />
          <h1>Reset password</h1>
        </header>
        <Alert
          variant="filled"
          severity="success"
          sx={{
            p: "35px",
            width: "35%",
          }}
        >
          New password set successfully.
          <Link to="/login">
            <span
              style={{
                fontSize: "1.15em",
                textDecoration: "underline",
              }}
            >
              Now you can Log in
            </span>
          </Link>
        </Alert>
      </div>
    );
  }
  return (
    <div>
      <header className="reset-pw-header">
        <MarkNotesIcon />
        <h1>Reset password</h1>
      </header>
      <form className="reset-pw" onSubmit={handleSubmit}>
        <Stack spacing={2} sx={{ marginBottom: 4 }}>
          <TextField
            type="password"
            label="Password"
            name="password"
            variant="outlined"
            required
            fullWidth
            onChange={(e) => handleOnChange(e)}
            value={pw.password}
            error={error.password !== ""}
            helperText={error.password}
          />
          <TextField
            type="password"
            label="Confirm Password"
            name="confirmPassword"
            variant="outlined"
            required
            fullWidth
            onChange={(e) => handleOnChange(e)}
            value={pw.confirmPassword}
            error={error.confirmPassword !== ""}
            helperText={error.confirmPassword}
          />
          <p className={errClass}>{errorReset?.data?.message}</p>
          <Button className="reset-pw-btn" variant="outlined" type="submit">
            Change password
          </Button>
        </Stack>
      </form>
    </div>
  );
}

export default PasswordReset;
